import { API,getScreeningId } from "../../utils/http";

export function getApplicationApi() {
	const screeningId = getScreeningId();
	return new Promise((resolve, reject) => {
		API.get("application", { params: { screeningId } })
			.then((r) => {
				console.log(r);
				const user = r.data.payload;
				// console.log(user);
				resolve(user);
			})
			.catch((e) => {
				reject(e);
			});
	});
}
